<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Requests</a></li>
          <li><a>Statuses</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Request Statuses</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar">
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by status code"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let statusCode of srStatusCodesList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg" alt="Left arrow icon">
                  <span>{{ statusCode && statusCode.code }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span class="card-content-text">Description:</span>
                  <span class="text">{{ statusCode?.description || 'NA' }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Created At:</span>
                  <span class="text">{{ statusCode?.createdAt | date: "dd MMM yyyy" }}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Updated At:</span>
                  <span class="text">{{ statusCode?.updatedAt | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" alt="Edit icon" title="Edit Status Code" (click)="getSrStatusCodeById(statusCode.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Status Code Not Found</div>
      </div>

      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Status Code</div>
                <button type="button" class="add-update-submit-button" (click)="addUpdateSrStatusCode()" [disabled]="statusCodesDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <!-- Status Code -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Status Code</mat-label>
                  <input matInput id="statusCode" type="text" formControlName="statuscode" autocomplete="off" placeholder="Enter status code"/>
                  <mat-hint><i>2–12 characters</i></mat-hint>
                  <mat-error *ngIf="(f.statuscode.dirty || f.statuscode.touched || submitted) && f.statuscode.errors">
                    <i>{{ f.statuscode.hasError('required') ? 'Status code is required.' : f.statuscode.hasError('minlength') ? 'Minimum 2 characters required.' : f.statuscode.hasError('maxlength') ? 'Maximum 12 characters allowed.' : '' }}</i>
                  </mat-error>
                </mat-form-field>
                <!-- Description -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Description</mat-label>
                  <textarea matInput id="description" rows="3" formControlName="description" autocomplete="off" placeholder="Enter description"></textarea>
                  <mat-hint><i>Maximum 50 characters</i></mat-hint>
                  <mat-error *ngIf="(f.description.dirty || f.description.touched || submitted) && f.description.errors">
                    <i>{{ f.description.hasError('maxlength') ? 'Maximum 50 characters allowed.' : '' }}</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>

